import esriId from '@arcgis/core/identity/IdentityManager';

/**
 * Registers the ArcGIS server token with the IdentityManager so that GIS services can be used.
 * https://developers.arcgis.com/javascript/latest/api-reference/esri-identity-IdentityManager.html#registerToken
 * @param {String} server - ArcGIS server url
 * @param {String} token - ArcGIS server token
 */
export const registerToken = async (server, token) =>
  await handleToken(server, token);

function handleToken(server = '', token = '') {
  const tokenProperties = {
    server,
    token,
  };

  esriId.registerToken(tokenProperties);

  // There is a sproradic issue that occurs where the IdentityManager dialog widget is rendered over
  // the Esri map, prompting the user to sign-in in order to access the resource. The cause could be
  // that a GIS service layer has changed or is unavailable. The snippet below checks if the dialog
  // widget is rendered, destroys the dialog widget instance, then attempts to register the token again.
  // https://community.esri.com/t5/arcgis-javascript-maps-sdk-questions/detect-or-prevent-the-arcgis-authentication-dialog/td-p/1047565
  // https://community.esri.com/t5/arcgis-javascript-maps-sdk-questions/disabling-the-esri-javascript-api-v4-x/td-p/1223257
  // https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Widget.html#visible
  // https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Widget.html#destroy
  esriId.on('dialog-create', () => {
    if (esriId?.dialog?.open || esriId?.dialog?.visible) {
      esriId.dialog.destroy();
      esriId.registerToken(tokenProperties);
    }
  });
}
